import { createSlice } from "@reduxjs/toolkit";

/**
 * Redux slice for managing user login details.
 * @module loginSlice
 * @requires @reduxjs/toolkit
 * @returns {object} The login slice reducer and actions.
 * @property {object} initialState - The initial state of the login slice.
 * @property {object} reducers - The reducers for the login slice.
 * @property {function} setUserDetails - Action to set user details in the state.
 * @example
 * import { setUserDetails } from './loginSlice';
 * dispatch(setUserDetails({ name: 'John Doe', email:'sdc@gm.com' }));
 */
const loginSlice = createSlice({
    name:'login',
    initialState:{
      userDetails:{}
    },
    reducers:{
        /**
         * Sets the user details in the state of the loginSlice.
         * @function
         * @param {Object} state - The state of the loginSlice.
         * @param {Object} action - The action object containing the payload of user details.
         * @returns {Object} The updated state of the loginSlice.
         */
        setUserDetails:(state,action)=> {
            state.userDetails = { ...action.payload };
        }
    }
})
export const {setUserDetails}=loginSlice.actions
export default loginSlice.reducer;